import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import PresaleInfo from './components/sections/PresaleInfo';
import StakingClaimSection from './components/sections/StakingClaimSection';
import RoadmapSection from './components/sections/RoadmapSection';
import TokenomicsSection from './components/sections/TokenomicsSection';
import BackgroundStars from './components/sections/BackgroundStars';
import { ThemeProvider } from './context/ThemeContext';
import { languageService } from './js/languageService';

function App() {
  useEffect(() => {
    // Initialize language service after a short delay to ensure DOM is ready
    const initLanguage = setTimeout(() => {
      languageService.updatePageContent();
    }, 100);

    // Listen for language changes
    const handleLanguageChange = () => {
      requestAnimationFrame(() => {
        languageService.updatePageContent();
      });
    };
    
    document.addEventListener('languageChanged', handleLanguageChange);
    
    return () => {
      clearTimeout(initLanguage);
      document.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className="App min-h-screen font-sans relative">
          {/* Background stars */}
          <BackgroundStars />
          
          {/* Main Content */}
          <div className="relative z-10">
            <Header />
            <main>
              <HeroSection />
              <PresaleInfo />
              <StakingClaimSection />
              <TokenomicsSection />
              <RoadmapSection />
            </main>
            <Footer />
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;